import api from "./api";

/**
 * Busca o perfil de faturamento do usuário logado.
 * - 200 → perfil existe (frontend pré-preenche o formulário)
 * - 404 → perfil ainda não cadastrado (frontend exibe formulário vazio)
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function fetchBillingProfile() {
  return api.get("/billing-profile");
}

/**
 * Cria ou atualiza o perfil de faturamento do usuário logado (upsert).
 * Chamado antes de redirecionar para o Mercado Pago.
 * @param {object} data - Dados do perfil (UserBillingProfileUpsertDto).
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function saveBillingProfile(data) {
  return api.post("/billing-profile", data);
}
